// extracted by mini-css-extract-plugin
export default {"tableHead":"styles_tableHead__cgDAH"};